import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Input, Label, LabelProps, InputProps, BaseModal, BaseModalProps } from '@anytag/shared-atoms';

export interface AddAnalyticsAccountModalProps extends BaseModalProps {
  loading?: boolean;
  onSubmit?: (accountName: string) => void;
  customInput?: { title?: LabelProps['title']; placeholder?: InputProps['placeholder'] };
}
export const AddAnalyticsComparableAccountModal = ({
  loading,
  onClose,
  onSubmit,
  customInput,
  ...restProps
}: AddAnalyticsAccountModalProps) => {
  const { t } = useTranslation();
  const [newAccount, setNewAccount] = useState('');

  useEffect(() => () => setNewAccount(''), []);

  const handleAddNewAccount = () => {
    if (!newAccount) return;

    onSubmit?.(newAccount);
  };

  return (
    <BaseModal
      onClose={onClose}
      footer={{
        cancelButton: { title: t('Button.Cancel'), onClick: onClose },
        submitButton: { title: t('Button.Add'), onClick: handleAddNewAccount, loading, disabled: !newAccount }
      }}
      {...restProps}
    >
      {customInput?.title ? <Label title={customInput.title} /> : null}
      <Input onChange={(e) => setNewAccount(e.target.value)} placeholder={customInput?.placeholder || ''} autoFocus />
    </BaseModal>
  );
};
